import React, {useEffect} from "react";

import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import {Button, message} from "antd";
import {useForm} from "antd/es/form/Form";

import api from "../../api";
import {DataCard} from "../helpers/cards/Card";
import {CustomTabs} from "../helpers/CustomTabs";
import {StandardForm} from "../helpers/forms/StandardForm";
import {ModalWindow} from "../helpers/modals/ModalWindow";
import {StandardTable} from "../helpers/TablePanel";

function CriticalityWeighting(props) {
	const columns = [
		{
			title: "Criticality",
			dataIndex: "criticality",
		},
		{title: "Weight", dataIndex: "weight"},
	];

	const fields = [
		{label: "Criticality", name: "criticality", _type: "text", required: true},
		{label: "Weight", name: "weight", _type: "number", required: true},
	];

	return (
		<div>
			<FieldSettings
				projectId={props.projectId}
				fields={fields}
				area={"criticality"}
				columns={columns}
				fieldsKeys={["criticality", "weight"]}
			/>
		</div>
	);
}

function ACWeighting(props) {
	const columns = [
		{
			title: "Criticality",
			dataIndex: "criticality",
		},
		{title: "Weight", dataIndex: "weight"},
	];

	const fields = [
		{label: "Criticality", name: "criticality", _type: "text", required: true},
		{label: "Weight", name: "weight", _type: "number", required: true},
	];

	return (
		<div>
			<FieldSettings
				projectId={props.projectId}
				fields={fields}
				area={"asset_consequence"}
				columns={columns}
				fieldsKeys={["criticality", "weight"]}
			/>
		</div>
	);
}

function FieldSettings(props) {
	const [isVisible, setVisible] = React.useState(false);
	const [data, setData] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [selectedValue, setSelectedValue] = React.useState({});

	useEffect(() => {
		getSettings();
	}, [props.projectId]);

	const columns = [
		...props.columns,
		{
			title: "Action",
			render: item => (
				<div>
					<EditOutlined onClick={() => handleEdit(item)} />
					<DeleteOutlined onClick={() => handleDelete(item)} style={{marginLeft: "10px"}} />
				</div>
			),
		},
	];

	const handleEdit = item => {
		setSelectedValue(item);
		setVisible(true);
		form.setFieldsValue(selectedValue);
	};

	const handleDelete = item => {
		setLoading(true);
		let dataSource = data;
		dataSource = dataSource.filter(i => !(i.criticality === item.criticality && i.weight === item.weight));
		setData(dataSource);
		saveToDB(dataSource);
	};

	const handleAdd = () => {
		setVisible(true);
	};

	const handleSave = () => {
		form.submit();
	};

	const handleCancel = () => {
		setVisible(false);
		form.resetFields(props.fieldsKeys);
	};

	const saveToDB = _data => {
		setLoading(true);
		api.post(`/projects/${props.projectId}/settings/${props.area}`, _data)
			.then(() => {
				message.success("Settings were updated successfully!");
				getSettings();
			})
			.finally(() => setLoading(false));
	};

	const getSettings = () => {
		api.get(`/projects/${props.projectId}/settings/${props.area}`).then(json => {
			const _data = json.data;
			if (!Array.isArray(_data.constants)) {
				setData([]);
			} else {
				setData(_data.constants);
			}
		});
	};

	const [form] = useForm();

	const handleFinish = values => {
		let dataSource = [...data];
		const find = dataSource.filter(i => i.criticality === values.criticality);
		if (selectedValue) {
			dataSource = dataSource.filter(i => i.criticality !== selectedValue.criticality);
			dataSource.push({...values, key: `${values.criticality}`});
		} else if (find.length === 1) {
			dataSource = dataSource.filter(i => i.criticality !== values.criticality);
			dataSource.push({...values, key: `${values.criticality}`});
		} else {
			dataSource.push({...values, key: `${values.criticality}`});
		}
		setData(dataSource);
		setVisible(false);
		form.resetFields(["criticality", "weight"]);
		saveToDB(dataSource);
	};

	useEffect(() => {
		form.setFieldsValue(selectedValue);
	}, [selectedValue]);

	return (
		<div>
			<Button
				onClick={handleAdd}
				type="primary"
				style={{
					marginBottom: 16,
					float: "right",
				}}>
				Add a row
			</Button>
			<StandardTable scroll={700} tableSize={"small"} loading={loading} columns={columns} data={data} />

			<ModalWindow title={"Add new row"} isModalVisible={isVisible} onOk={handleSave} onCancel={handleCancel}>
				<StandardForm initialValues={selectedValue} onFinish={handleFinish} fields={props.fields} form={form} />
			</ModalWindow>
		</div>
	);
}

export function Weighting(props) {
	const projectId = props.location.pathname.split("/")[2];

	const tabsData = [
		{
			name: "Criticality",
			key: "criticality",
			children: <CriticalityWeighting projectId={projectId} />,
		},
		{
			name: "Asset Consequence",
			key: "assetConsequence",
			children: <ACWeighting projectId={projectId} />,
		},
	];

	return (
		<DataCard style={{margin: 10}}>
			<CustomTabs tabsData={tabsData} />
		</DataCard>
	);
}
